var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H14C15.1046 2 16 2.89543 16 4V12C16 13.1046 15.1046 14 14 14H2C0.89543 14 0 13.1046 0 12V4C0 2.89543 0.89543 2 2 2ZM2 7V12H14V6.89443L8 10L2 7ZM2 5L8.00002 7.98803L14 5V4H2V5Z",
    fill: "#2D7738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail);
export default __webpack_public_path__ + "static/media/ic-mail.39e03bf176fc686d890eaa240589bfe3.svg";
export { ForwardRef as ReactComponent };